





















































































import { computed, defineComponent, ref, toRefs, watch } from '@vue/composition-api'
import { omega } from '@didi/driver-biz-sdk'
import Panel from './panel.vue'
import { usePageInfo } from '@/store'
import { storeToRefs } from 'pinia'
import { QA_URL, RULE_URL } from '@/common/biz/constants'

export default defineComponent({
  name: 'rule',
  props: {
    companyId: {
      type: Number,
      default: 0
    },
    qaLink: {
      type: String,
      default: ''
    },
    ruleLink: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const store = usePageInfo()
    const { pageInfo } = storeToRefs(store)
    const isDriverDay = computed(() => store.isDriverDay)
    const { rule, ext } = toRefs(pageInfo.value)
    const activityStatus = computed(() => ext.value.activity_status)

    const linkToPage = (type: 'qa'|'rule') => {
      omega.trackEvent(activityStatus.value === 1 ? 'am_c_insure_medinsurland_rule_ck' : 'am_c_insure_endowmentbjion_rule_ck')
      if (type === 'qa') {
        window.location.href = props.qaLink || QA_URL
      } else if (type === 'rule') {
        window.location.href = props.ruleLink || RULE_URL
      }
    }
    const demo = computed(() => {
      return [{
        title: '可选保障方案：',
        content: [{
          type: 'A 免费保障',
          desc: [
            '百万医疗1份+意外及突发急性病身故1份',
            '保费255元，补贴后<span class="high-light">无需自费</span>'
          ]
        }, {
          type: 'B 多重保障',
          desc: isDriverDay.value ? [
            '百万医疗1份+意外及突发急性病身故1份+住院津贴2份',
            '保费455元，补贴后<span>仅需花费55元</span>'
          ] : [
            '百万医疗1份+意外及突发急性病身故1份+住院津贴1份',
            '保费355元，补贴后<span class="high-light">仅花费55元</span>'
          ]
        }]
      }, {
        title: '若存在《健康告知》中所含疾病及其他情况，则可选择以下保障方案：',
        content: [{
          type: 'A 免费保障',
          desc: isDriverDay.value ? [
            '意外及突发急性病身故2份+住院津贴2份',
            '保费400元，补贴后<span class="high-light">无需自费</span>'
          ] : [
            '意外及突发急性病身故2份+住院津贴1份',
            '保费300元，补贴后<span class="high-light">无需自费</span>'
          ]
        }, {
          type: 'B 多重保障',
          desc: isDriverDay.value ? [
            '意外及突发急性病身故2份+住院津贴3份',
            '保费500元，补贴后<span class="high-light">仅花费100元</span>'
          ] : [
            '意外及突发急性病身故2份+住院津贴2份',
            '保费400元，补贴后<span class="high-light">仅花费100元</span>'
          ]
        }]
      }]
    })
    const infoWrapper = ref<InstanceType<typeof HTMLDivElement>>()
    const exampleWrapper = ref<InstanceType<typeof HTMLDivElement>>()
    watch(infoWrapper, () => {
      if (infoWrapper.value && exampleWrapper.value) {
        exampleWrapper.value.style.paddingTop = infoWrapper.value.clientHeight + 'px'
      }
    })
    return {
      linkToPage,
      demo,
      infoWrapper,
      exampleWrapper,
      rule,
      isDriverDay
    }
  },
  components: {
    Panel
  }
})
